import React from 'react';
import { connect } from 'react-redux';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteSpecTestSection } from './Section';
import { renderRLHeader } from './Helpers';
import { PatientCareCenterNoteObjectiveSpecTestsPanel } from './SpecTestsPanel';

class SpecTestsNeurodynamicAssessment extends React.Component {

    render() {
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSpecTestSection id='obj_spec_tests_NeurodynamicAssessment' name='Neurodynamic Assessment' visible={false}>
                    {renderRLHeader()}
                    {
                        Object.keys(this.props.panels)
                            .map(key => {
                                return (<PatientCareCenterNoteObjectiveSpecTestsPanel key={this.props.panels[key].MOPNO} panelId={this.props.panels[key].MOPNO} header='Neurodynamic Assessment' />);
                            })
                    }
                </PatientCareCenterNoteSpecTestSection>
            );
        } else {
            return (
                <span />
            )
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        tsno: tsno,
        panels: getPanels(noteId, 'SpecialTest', 'NeurodynamicAssessment'),
    };
}

const connectedSpecTestsNeurodynamicAssessment = connect(mapStateToProps)(SpecTestsNeurodynamicAssessment);
export { connectedSpecTestsNeurodynamicAssessment as SpecTestsNeurodynamicAssessment };



